module.exports = __webpack_public_path__ + "img/24_60.92b103dd.png";